import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';
import { Row } from '@design-system/components/grid/grid';

type DeletePoseModalProps = {
  poseName: string;
  onConfirm: () => void;
  onClose: () => void;
};

export const DeletePoseModal = (p: DeletePoseModalProps) => (
  <Modal
    isOpen
    onClose={p.onClose}
    title="Delete this pose?"
    description={`"${p.poseName}" will no longer show in the pose guide for this challenge. This won't affect any before/after photos consumers have already submitted.`}
    footer={
      <Row gap="m" style={{ justifyContent: 'flex-end' }}>
        <Button color="neutral" variant="text" onClick={p.onClose}>
          Cancel
        </Button>
        <Button color="error" variant="filled" onClick={p.onConfirm}>
          Delete
        </Button>
      </Row>
    }
  />
);
